var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{class:[
    _vm.$style.flexContainer,
    _vm.$style.attributesHeader,
    _vm.$style.sectionGeneralMargin,
  ]},[_c('div',{class:_vm.$style.spAttributeHeader},[_vm._v(" Service provider attribute JSON path ")]),_c('div',{class:_vm.$style.appAttributeHeader},[_vm._v(" JumpCloud attribute ")]),_c('div',{class:_vm.$style.actions},[_c('a',{class:{[_vm.$style.disabled]: !_vm.enablePreview},attrs:{"href":"javascript:void(0);"},on:{"click":_vm.handlePreview}},[_vm._v(" Preview ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }